<template>
  <v-form ref="passwordForm">
    <v-overlay absolute :value="initialLoad">
      <v-progress-circular
        indeterminate
        rotate="15"
        size="60"
        width="7"
        color="light-blue"
      ></v-progress-circular>
    </v-overlay>
    <v-card v-if="form.ok == true">
      <v-stepper
        class="specific"
        v-model="etape"
        v-if="form.compteParticipant == true"
      >
        <v-stepper-header>
          <v-stepper-step :complete="etape > 1" step="1">
            {{ $t('registration.otp') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="etape > 2" step="2">
            {{ $t('registration.presentation') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="etape > 3" step="3">
            {{ $t('registration.cgu.title').toUpperCase() }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => checkDataConnexionIfOk]"
            :complete="etape > 4"
            step="4"
          >
            {{ $t('registration.dataConnexion').toUpperCase() }}
            <small>{{ alertMessageDataConnexion }}</small>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => checkDataConfidentialityIfOk]"
            :complete="etape > 5"
            step="5"
          >
            {{ $t('registration.dataConnexionSecret').toUpperCase() }}
            <small>{{ alertMessageConfidentialite }}</small>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => checkIfDMCValide]"
            :complete="etape > 6"
            step="6"
          >
            {{ $t('registration.validationDMC.title').toUpperCase() }}
            <small>{{ alertMessageAccesDMC }}</small>
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="specific">
            <confirmation-sms
              @cancelAuth="cancelActivationCompte"
              :ciemException="ciemException"
              @confirm="validerOTP"
              :loading="loading"
              :tel="tel"
            />
          </v-stepper-content>

          <v-stepper-content step="2" class="specific">
            <v-card>
              <v-card-title
                class="mb-5 pink darken-1 justify-center white--text"
              >
                {{ $t('registration.lireTout') }}</v-card-title
              >
              <v-card-text>
                <span
                  v-dompurify-html="form.messages.presentationParticipant"
                  style="color: rgba(0, 0, 0, 0.87); overflow: auto"
                />
              </v-card-text>
            </v-card>

            <v-card class="mt-3" elevation="2" outlined>
              <v-btn text @click="cancelActivationCompte()">
                {{ $t('button.cancel') }}
              </v-btn>
              <v-btn color="primary" @click="etape = 3">
                {{ $t('button.next') }}
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3" class="specific">
            <v-card>
              <v-card-title
                class="mb-5 pink darken-1 justify-center white--text"
              >
                {{ $t('registration.lireTout') }}</v-card-title
              >
              <v-card-text>
                <span
                  v-dompurify-html="form.messages.cgguparticipant"
                  style="color: rgba(0, 0, 0, 0.87)"
                />
              </v-card-text>
            </v-card>
            <v-card class="mt-3" elevation="2" outlined>
              <v-btn text @click="etape = 2">
                {{ $t('button.previous') }}
              </v-btn>
              <v-btn color="success" @click="etape = 4">
                {{ $t('registration.cgu.lu') }}
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="4" class="specific">
            <v-card class="mb-5" color="">
              <v-card-text>
                <span
                  style="color: rgba(0, 0, 0, 0.87)"
                  v-dompurify-html="
                    $t('registration.donneesConnexion.presentation')
                  "
                />
              </v-card-text>
            </v-card>
            <v-card class="mb-5" color="">
              <v-card-title>
                <span
                  class="mb-5 cyan darken-1 white--text"
                  v-dompurify-html="
                    $t('registration.donneesConnexion.explication')
                  "
                />
              </v-card-title>
              <v-card-text>
                <v-layout row>
                  <v-flex>
                    <v-text-field
                      v-model="form.portablePersonnel"
                      class="specific"
                      :label="$t('registration.portablePersonnel')"
                      :rules="[
                        obligatoireRule(),
                        serveurRule('form.portablePersonnel'),
                      ]"
                      :error-messages="$errors($v.form.portablePersonnel)"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row mt-5>
                  <v-flex>
                    <v-text-field
                      class="specific"
                      v-model="form.emailPersonnel"
                      :label="$t('registration.emailPersonnel')"
                      :rules="[
                        obligatoireRule(),
                        serveurRule('form.emailPersonnel'),
                      ]"
                      :error-messages="$errors($v.form.emailPersonnel)"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class="mt-3" elevation="2" outlined>
              <v-btn text @click="etape = 3">
                {{ $t('button.previous') }}
              </v-btn>
              <v-btn
                color="primary"
                @click="validerEtapeIdentifiantsConnexion()"
              >
                {{ $t('button.next') }}
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="5" class="specific">
            <v-card>
              <v-card-text>
                <passwordForm
                  @emitPassword="emitPassword"
                  @emitConfirmation="emitConfirmation"
                />
                <v-row class="mb-5">
                  <v-select
                    v-model="form.questionSecrete"
                    :items="this.enum.questions"
                    :item-text="$t('question.label')"
                    item-value="id"
                    :label="$t('question.changeDialog.label')"
                    dense
                    hide-details="auto"
                    filled
                    :error-messages="$errors($v.form.questionSecrete)"
                  >
                  </v-select>
                </v-row>
                <v-row class="mt-5">
                  <v-text-field
                    v-model="form.reponseQuestionSecrete"
                    filled
                    dense
                    :label="$t('question.changeDialog.response')"
                    autocomplete="current-password"
                    :error-messages="$errors($v.form.reponseQuestionSecrete)"
                  />
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mt-3" elevation="2" outlined>
              <v-btn text @click="precedentConfidentiel()">
                {{ $t('button.previous') }}
              </v-btn>
              <v-btn color="primary" @click="validerConfidentiel()">
                {{ $t('button.next') }}
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="6" class="">
            <v-card
              class="mt-5"
              style="min-height: 53px"
              elevation="2"
              outlined
            >
              <v-card-text
                class="text-caption red--text text--darken-1"
                style="font-size: 16px !important; font-weight: bold !important"
                >{{ checkboxErrors }}</v-card-text
              >
            </v-card>
            <v-card class="mt-5" elevation="2" outlined>
              <v-card-text
                :class="form.accepterDMC == true ? 'green lighten-1' : ''"
              >
                <v-layout row>
                  <v-flex style="max-width: 50px">
                    <v-checkbox v-model="form.accepterDMC" />
                  </v-flex>
                  <v-flex md11>
                    <p class="accept-text">
                      <strong>{{
                        $t('registration.validationDMC.oui')
                      }}</strong>
                      {{ $t('registration.validationDMC.accepter') }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mt-5" elevation="2" outlined>
              <v-card-text
                :class="form.refuserDMC == true ? 'red lighten-1' : ''"
              >
                <v-layout row>
                  <v-flex style="max-width: 50px">
                    <v-checkbox v-model="form.refuserDMC" />
                  </v-flex>
                  <v-flex md11>
                    <!-- <textarea
                      readonly
                      style="width: -webkit-fill-available"
                      :value="$t('registration.validationDMC.refuser')"
                    /> -->
                    <p class="accept-text">
                      <strong>{{
                        $t('registration.validationDMC.non')
                      }}</strong>
                      {{ $t('registration.validationDMC.refuser') }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mt-5" elevation="2" outlined>
              <v-btn text @click="precedentAccesDMC()">
                {{ $t('button.previous') }}
              </v-btn>
              <v-btn
                :disabled="form.refuserDMC == form.accepterDMC"
                color="primary"
                @click="creerCompte()"
              >
                {{ $t('registration.activerCompte') }}
              </v-btn>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <!-- comptes correspondants -->
      <v-stepper v-model="etape" v-else>
        <v-stepper-header>
          <v-stepper-step :complete="etape > 1" step="1">
            {{ $t('registration.presentation').toUpperCase() }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="etape > 2" step="2">
            {{ $t('registration.dataConnexion').toUpperCase() }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            {{ $t('registration.dataConnexionSecret').toUpperCase() }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="specific">
            <v-card>
              <v-card-title
                class="mb-5 pink darken-1 justify-center white--text"
              >
                {{ $t('registration.lireTout') }}</v-card-title
              >
              <v-card-text>
                <span
                  v-dompurify-html="form.messages.presentationCorrespondant"
                  style="color: rgba(0, 0, 0, 0.87); overflow: auto"
                />
              </v-card-text>
            </v-card>

            <v-card class="mt-3" elevation="2" outlined>
              <v-btn text @click="cancelActivationCompte()">
                {{ $t('button.cancel') }}
              </v-btn>
              <v-btn color="primary" @click="etape = 2">
                {{ $t('button.next') }}
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2" class="specific">
            <v-card class="mb-5" color="">
              <v-card-text>
                <v-layout row>
                  <v-flex>
                    <v-text-field
                      class="specific"
                      :label="$t('registration.portableProfessionnel')"
                      v-model="form.portablePersonnel"
                      autocomplete="off"
                      readonly
                      disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row mt-5>
                  <v-flex>
                    <v-text-field
                      class="specific"
                      :label="$t('registration.emailProfessionnel')"
                      v-model="form.emailPersonnel"
                      :rules="[
                        obligatoireRule(),
                        serveurRule('form.emailPersonnel'),
                      ]"
                      :error-messages="$errors($v.form.emailPersonnel)"
                      autocomplete="new-password"
                      readonly
                      disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class="mt-3" elevation="2" outlined>
              <v-btn text @click="etape = 1">
                {{ $t('button.previous') }}
              </v-btn>
              <v-btn color="primary" @click="etape = 3">
                {{ $t('button.next') }}
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3" class="specific">
            <v-card>
              <v-card-text>
                <passwordForm
                  @emitPassword="emitPassword"
                  @emitConfirmation="emitConfirmation"
                />
                <v-row class="mb-5">
                  <v-select
                    v-model="form.questionSecrete"
                    :items="this.enum.questions"
                    :item-text="$t('question.label')"
                    item-value="id"
                    :label="$t('question.changeDialog.label')"
                    dense
                    hide-details="auto"
                    filled
                    :error-messages="$errors($v.form.questionSecrete)"
                  >
                  </v-select>
                </v-row>
                <v-row class="mt-5">
                  <v-text-field
                    v-model="form.reponseQuestionSecrete"
                    filled
                    dense
                    :label="$t('question.changeDialog.response')"
                    autocomplete="current-password"
                    :error-messages="$errors($v.form.reponseQuestionSecrete)"
                  />
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mt-3" elevation="2" outlined>
              <v-btn text @click="etape = 2">
                {{ $t('button.previous') }}
              </v-btn>
              <v-btn color="primary" @click="creerCompte()">
                {{ $t('registration.activerCompte') }}
              </v-btn>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <v-card v-else-if="form.notFound">
      <v-card-title>
        {{ $t('registration.expire.title') }}
      </v-card-title>
      <v-card-text>
        {{ $t('registration.expire.text') }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          :to="{
            name: 'Login',
            params: { namespaceonly: true },
          }"
        >
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="form.foundButExpired">
      <v-card-title>
        {{ $t('registration.expire.title') }}
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-flex md2>
            {{ $t('registration.expire.resendregistration') }}
          </v-flex>
          <v-flex md3>
            <v-btn
              :loading="loading"
              color="pink"
              block
              dark
              @click="resendRegistration"
            >
              {{ $t('registration.expire.resendregistrationButton') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card v-else-if="nouveauLienEnvoye">
      <v-card-text>
        {{ $t('registration.expire.textNewLienEnvoye') }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          :to="{
            name: 'Login',
            params: { namespaceonly: true },
          }"
        >
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { required, sameAs, email } from 'vuelidate/lib/validators'
import { alert } from '@/commun/alertMessage'
import Api from '@/utils/api'
import _ from 'lodash'
import toasted from '@/utils/toasted'
import PasswordForm from '@/view/Forgot/PasswordForm'
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import { validationMixin } from 'vuelidate'
import ValidationRules from '@/plugins/mixins/ValidationRules'

export default {
  beforeCreate() {
    let uri = 'registration/otp?token=' + this.$route.query.token
    new Api('registration/token?token=' + this.$route.query.token, 'oauth/')
      .post()
      .then((response) => {
        this.initForm(response.body)
        this.setInitialFormDigest()
      })
      .catch(() => {
        // TODO gestion du cas d'erreur not found
      })
    new Api(uri, 'oauth/')
      .post()
      .then((response) => {
        if (!response.bodyText) {
          toasted.error('registration.otpError')
        }
        this.tel = response.bodyText
      })
      .catch(() => {
        toasted.error('registration.otpError')
      })
    new Api('listeQuestion', 'oauth/registration/')
      .get()
      .then((response) => {
        this.enum.questions = response.body
      })
      .catch(() => {
        // TODO gestion du cas d'erreur not found
      })
  },
  components: {
    passwordForm: PasswordForm,
  },
  mixins: [ErrorServeur, validationMixin, ValidationRules],

  data() {
    return {
      empty: '',
      etape: 1,
      ciemException: alert(),
      error: null,
      success: null,
      form: {
        ok: true,
        emailProfessionnel: null,
        emailPersonnel: null,
        portableProfessionnel: null,
        portablePersonnel: undefined,
        password: undefined,
        confirmPassword: undefined,
        accepterDMC: false,
        refuserDMC: false,
        compteParticipant: true,
        questionSecrete: null,
        reponseQuestionSecrete: null,
        foundButExpired: false,
        notFound: false,
        messages: {
          presentationParticipant: null,
          cgguparticipant: null,
          presentationCorrespondant: null,
        },
      },
      retour: false,
      response: {
        userExtraciemDmc: {},
        ok: false,
        exception: null,
      },
      loading: false,
      enum: {
        questions: [],
      },
      nouveauLienEnvoye: false,
      alertMessageAccesDMC: null,
      alertMessageDataConnexion: null,
      alertMessageConfidentialite: null,
      tel: '+***********',
      initialLoad: true,
    }
  },
  beforeDestroy() {
    this.resetAlert()
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return 'Sign-up'
        case 2:
          return 'Create a password'
        default:
          return 'Account created'
      }
    },
    checkboxErrors() {
      if (
        this.form.compteParticipant &&
        this.form.accepterDMC == this.form.refuserDMC
      ) {
        return this.$t('registration.validationDMC.error')
      } else {
        return ''
      }
    },
    checkIfDMCValide() {
      return !(
        this.form.compteParticipant &&
        this.form.accepterDMC == this.form.refuserDMC &&
        this.etape > 5
      )
    },
    checkDataConnexionIfOk() {
      return this.alertMessageDataConnexion == null
    },
    checkDataConfidentialityIfOk() {
      return this.alertMessageConfidentialite == null
    },
  },
  watch: {
    'form.accepterDMC'(val) {
      if (val) {
        this.form.refuserDMC = false
      }
    },
    'form.refuserDMC'(val) {
      if (val) {
        this.form.accepterDMC = false
      }
    },
    'form.anglaisUniquement'(val) {
      if (val) {
        this.$i18n.locale = 'en_EN'
      } else {
        this.$i18n.locale = 'fr_FR'
      }
    },
    etape() {
      window.scrollTo(0, 0)
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.$v.form.$touch()
    })
  },
  methods: {
    validerOTP(form) {
      let uri = 'registration/otp?token=' + this.$route.query.token
      new Api(uri, 'oauth/')
        .put(form)
        .then((response) => {
          if (response.body.ok === true) {
            this.etape = 2
          } else {
            response.body.ciemException.messages.forEach((m) => {
              if (m.level == 'ERROR') {
                this.ciemException.error = this.$t(m.errorCode)
              } else if (m.level == 'WARN') {
                this.ciemException.warning = this.$t(m.errorCode)
              }
            })
          }
        })
        .catch((response) => {
          if (
            response.error_description &&
            response.error_description.startsWith('tentative.3')
          ) {
            this.ciemException.error = this.$t(
              'login.' + response.error_description,
            )
            this.resetAlert()
            this.$router.push({
              name: 'Login',
            })
            this.$auth.logout()
            toasted.error('login.' + response.error_description)
          } else if (
            response.error_description &&
            response.error_description.startsWith('tentative')
          ) {
            this.ciemException.warning = this.$t(
              'login.' + response.error_description,
            )
          } else {
            toasted.error(response.error)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    precedentConfidentiel() {
      this.alertMessageConfidentialite = null
      this.etape = 4
    },
    validerConfidentiel() {
      this.$v.$touch()
      const ok =
        this.__validerPassword() &&
        !this.$v.form.questionSecrete.$invalid &&
        !this.$v.form.reponseQuestionSecrete.$invalid
      if (ok) {
        this.etape = 6
      } else {
        this.alertMessageConfidentialite = this.$t(
          'registration.confidentielIncorrect',
        )
      }
    },
    precedentAccesDMC() {
      this.alertMessageAccesDMC = null
      this.etape = 5
    },

    validerEtapeIdentifiantsConnexion() {
      const ok = this.form.emailPersonnel && this.form.portablePersonnel
      if (ok) {
        this.loading = true
        new Api(
          'registration/validerDonnesConnexion?token=' +
            this.$route.query.token,
          'oauth/',
        )
          .post(this.form)
          .then(
            (response) => {
              if (response.body.ok === true) {
                this.alertMessageDataConnexion = null
                this.__reset()
                this.$refs.passwordForm.validate()
                this.etape = 5
              } else {
                response.body.ciemException.messages.forEach((m) => {
                  if (m.level == 'ERROR') {
                    toasted.error(this.$t(m.errorCode))
                  }
                })
                this.alertMessageDataConnexion = this.$t(
                  'registration.dataConnexionIncorrecte',
                )
              }
            },
            (response) => {
              this.errorsHandler(response)
              if (this.errors.fields != null) {
                this.alertMessageDataConnexion = this.$t(
                  'registration.dataConnexionIncorrecte',
                )
              }
            },
          )
          .catch((response) => {
            toasted.info(response.message)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.alertMessageDataConnexion = this.$t(
          'registration.dataConnexionIncorrecte',
        )
      }
    },
    getForms() {
      return [this.$refs.passwordForm]
    },
    __validerPassword() {
      this.resetErreur()
      const ok = this.$refs.passwordForm.validate()
      return ok
    },
    initForm(loaded) {
      this.form = loaded
      if (loaded.exception && !_.isEmpty(loaded.exception.messages)) {
        loaded.exception.messages.forEach((m) => {
          if (m.level == 'ERROR') {
            this.error = this.$t(m.errorCode)
            //this.ciemException.error = this.$t(m.errorCode);
          } else if (m.level == 'INFO') {
            this.success = this.$t(m.errorCode)
            //this.ciemException.success = this.$t(m.errorCode);
          }
        })
      }
      this.initialLoad = false
    },
    cancelActivationCompte() {
      this.$router.push({
        name: 'Login',
      })
    },
    creerCompte() {
      // envoyer un code sur le portable de l'utilisateur
      this.$v.$touch()

      if (
        this.form.compteParticipant == true &&
        this.form.accepterDMC == this.form.refuserDMC
      ) {
        this.alertMessageAccesDMC = this.$t('registration.cguIncomplet')
      } else {
        this.alertMessageCgu = null

        const ok =
          this.__validerPassword() &&
          (!this.form.compteParticipant ||
            (this.form.compteParticipant == true &&
              this.form.accepterDMC != this.form.refuserDMC))

        if (ok) {
          this.loading = true
          let uri = 'registration/confirmation?token=' + this.$route.query.token
          new Api(uri, 'oauth/')
            .post(this.form)
            .then(
              (response) => {
                if (response.body.ok === true) {
                  toasted.info('registration.confirm.success')
                  this.$router.push({
                    name: 'Login',
                  })
                } else {
                  response.body.ciemException.messages.forEach((m) => {
                    if (m.level == 'ERROR') {
                      toasted.error(this.$t(m.errorCode))
                    }
                  })
                }
              },
              (response) => {
                this.errorsHandler(response)
                //this.emailErrors.push(this.$t('errors.emailNotValid'));

                //this.$refs.form.validate()

                // toasted.error('form.error');
              },
            )
            .catch((response) => {
              //this.errorsHandler(response);
              toasted.info(response.message)
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    resendRegistration() {
      this.loading = true
      let uri = 'registration/resend?token=' + this.$route.query.token
      new Api(uri, 'oauth/')
        .post()
        .then(
          (response) => {
            if (response.body === true) {
              this.nouveauLienEnvoye = true
              this.form.foundButExpired = false
            }
          },
          (error) => toasted.error(error.body),
        )
        .catch(() => {
          // TODO gestion du cas d'erreur not found
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetAlert() {
      this.error = null
      this.success = null
    },
    emitPassword(value) {
      this.form.password = value
    },

    emitConfirmation(value) {
      this.form.confirmPassword = value
    },
  },
  validations() {
    return {
      form: {
        emailPersonnel: {
          required,
          email,
        },
        portablePersonnel: {
          required,
        },
        password: {
          required,
        },
        confirmPassword: {
          required,
          sameAsPassword: sameAs('password'),
        },
        questionSecrete: {
          required,
        },
        reponseQuestionSecrete: {
          required,
        },
      },
    }
  },
}
</script>
<style scoped>
.specific >>> .v-stepper__wrapper {
  overflow: inherit !important;
}

.specific >>> .v-stepper__label {
  max-width: 14em;
}

.specific >>> .v-card__title {
  word-break: unset;
}

.specific >>> .v-stepper__header {
  flex-wrap: nowrap;
}

.accept-text {
  margin-bottom: 0;
  color: black;
}
</style>
